import React, { useEffect, useMemo, useState } from 'react';
import { ITableauReportType, ReportInfoType } from '../../pages/report/type';
import ErrorInfo from '../../pages/report/component/errorInfo';
import Loading from '@/pages/dashboard/components/Loadings';
import { getLocale } from 'umi';
import { IS_WOA } from '@/pages/home/_config/config';
import { getTicket } from '@home/services/report';
import classNames from 'classnames';

const INIT_REPORT_INFO: ReportInfoType = {
  loading: true,
  noReport: false,
  errMsg: '',
  reportUrl: '',
};

export default (props: ITableauReportType) => {
  const { url, className = '', style = {}, onSuccess, onFail, apiUrl = '/api/v1/dashboard/getTicket', ...restProps } = props || {};
  const [reportInfo, setReportInfo] = useState<ReportInfoType>(INIT_REPORT_INFO);
  const locale = getLocale();
  const isEn = locale === 'en-US';

  useEffect(() => {
    const openIframeReport = () => {
  
      setReportInfo({
        ...INIT_REPORT_INFO,
      });
  
      // 跟后端对协议
      const params = {
        content_url: url,
        ...restProps
        // user_id: userId,
        // game_code: gameCode,
        // studio_code: studioCode
      };
  
      getTicket(params, apiUrl).then((data) => {
        //  同步老版本的逻辑 加了&& data?.full_url_inner 的判断条件
        const iframe =(IS_WOA && data?.full_url_inner) ? data?.full_url_inner: (data?.full_url || '');
        setReportInfo({
          loading: false,
          reportUrl: iframe,
          noReport: !iframe,
          errMsg: data?.msg || ''
        });
        onSuccess?.();
      }).catch(()=>{
        setReportInfo({
          ...INIT_REPORT_INFO,
          loading: false,
          noReport: true,
        });
        onFail?.();
      });
    };

    openIframeReport();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url]);

  const errorInfo = useMemo(() => {
    if (reportInfo.noReport) {
      return <ErrorInfo isEn={isEn} />;
    }
    return null;
  }, [reportInfo, isEn]);

  return (
    <>
      {reportInfo.loading ? (
        <Loading />
      ) : (
        <>
          {errorInfo || (
            <div className={classNames('dtb-db-iframe-wrap db-report-tableau iframe-wrap-padding', className)} style={style}>
              <iframe
                title="looker"
                className='dtb-db-iframe'
                src={reportInfo.reportUrl}
              />
            </div>
          )}
        </>
      )}
    </>
  );
};
